<template>
  <GenericInfo api-endpoint="permission" :type="type" @add="addsave" @save="addsave">
    <template v-slot:title>
      <div class="input-group-add">
        <h1 v-if="type === 2">{{ $t('projectInformation') }}</h1>
        <h1 v-else-if="type === 1">{{ $t('projectEdit') }}</h1>
        <h1 v-else>{{ $t('addProject') }}</h1>
      </div>
    </template>
    <template v-slot:info>
      <div class="input-group-add">
        <label for="nickname" class="label-add">{{ $t('name') }}:</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="name"
          class="input-add"
          v-model="inputNameValue"
          @input="validateNameValue"
          :disabled="type === 2"
        />
      </div>
      <p v-if="errorNameMessage" class="err-msg">{{ errorNameMessage }}</p>
    </template>
  </GenericInfo>
  <div class="group-add" style="height: 10px" />
  <InfoTabView :type="type" v-if="type === 2" />
  <div class="group-add" style="height: 10px" />
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import Swal from 'sweetalert2';
import { validateName } from '../utils/stringValid';
import { fetchData, insertData, updateData } from '../utils/api';
import GenericInfo from '../generic/GenericInfo.vue';
import InfoTabView from './ProjectInfoTabView.vue';

export default {
  components: {
    GenericInfo,
    InfoTabView,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const page = ref('project');
    const btnLabel = ref(t('add'));
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const inputNameValue = ref('');
    const route = useRoute();

    if (props.type !== 0) {
      onMounted(async () => {
        id.value = route.params.id;
        fetchData(t, `${apiBaseUrl}/info/${page.value}`, id.value).then((response) => {
          if (response.data) {
            inputNameValue.value = response.data.result.name;
          }
        });
      });
    }

    return {
      t,
      page,
      btnLabel,
      apiBaseUrl,
      id,
      inputNameValue,
      route,
    };
  },
  data() {
    return {
      errorNameMessage: '',
      title: this.$t('confirmAdd'),
    };
  },
  methods: {
    validateNameValue() {
      if (validateName(this.inputNameValue, 2, 24)) {
        this.errorNameMessage = '';
        return true;
      }
      this.errorNameMessage = this.$t('incorrectFormat');
      return false;
    },
    validateAllInputfield() {
      let check = 0;
      if (this.type !== 0) {
        this.title = this.$t('confirmSave');
      }
      if (!this.validateNameValue()) {
        check += 1;
      }
      return check;
    },
    addsave() {
      if (this.validateAllInputfield() > 0) {
        Swal.fire({
          title: this.$t('checkFormatError'),
          icon: 'error',
        });
        return;
      }
      Swal.fire({
        icon: 'warning',
        title: this.title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.type === 1) {
            const data = JSON.stringify({
              id: this.id,
              name: this.inputNameValue,
            });
            updateData(
              this.t,
              `${this.apiBaseUrl}/edit/${this.page}`,
              data,
              this.$router,
              '/project',
            );
          } else {
            const data = JSON.stringify({
              name: this.inputNameValue,
            });
            insertData(
              this.t,
              `${this.apiBaseUrl}/new/${this.page}`,
              data,
              this.$router,
              '/project',
            );
          }
        }
      });
    },
    removeGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.removeGroup(item);
      }
    },
    addGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.addGroup(item);
      }
    },
    getSidData() {
      return JSON.stringify({
        sid: this.route.params.id,
      });
    },
  },
};
</script>
